import { useTheme } from "PFApp/theme_context_provider/theme_context_provider_context";
import { MultiToggle } from "PFComponents/multi_toggle";
import { useTranslation } from "react-i18next";

export const ThemeToggle = () => {
  const { t } = useTranslation("translation", { keyPrefix: "themes" });
  const { theme, changeTheme, themes } = useTheme();

  const options = themes.map((theme) => ({ id: theme, value: t(theme as unknown as TemplateStringsArray) }));

  return <MultiToggle controlledValue={theme} options={options} onChange={changeTheme} />;
};
